import React from 'react';

const RefundPolicy = () => (
  <div style={{ padding: '2rem' }}>
    <h2>Refund and Cancellation Policy</h2>
    <p>We provide refunds only under specific conditions. Please contact our support team to initiate a refund.</p>
    <p>Refunds will be processed within 7-10 business days.</p>
    <p>Cancellation of orders is allowed only before the processing has begun.</p>
  </div>
);

export default RefundPolicy;
